import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  DEFAULT_JFROG_TOKEN_DURATION,
  JFROG_TOKEN_DURATIONS,
  type JFrogTokenDuration,
} from "@/lib/jfrog-token-duration";
import React from "react";

interface JFrogTokenDurationSelectProps {
  value: JFrogTokenDuration;
  onValueChange: (value: JFrogTokenDuration) => void;
  id?: string;
  className?: string;
}

export function JFrogTokenDurationSelect({ value, onValueChange, id, className }: JFrogTokenDurationSelectProps) {
  const generatedId = React.useId();
  const selectId = id ?? generatedId;

  return (
    <div className={className}>
      <Label htmlFor={selectId} className="mb-2 block text-sm font-medium">
        Token duration
      </Label>
      <Select value={value} onValueChange={(next) => onValueChange(next as JFrogTokenDuration)}>
        <SelectTrigger id={selectId} className="w-full max-w-xs">
          <SelectValue placeholder="Select token duration..." />
        </SelectTrigger>
        <SelectContent>
          {(
            Object.entries(JFROG_TOKEN_DURATIONS) as [
              JFrogTokenDuration,
              (typeof JFROG_TOKEN_DURATIONS)[JFrogTokenDuration],
            ][]
          ).map(([key, option]) => (
            <SelectItem key={key} value={key}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export { DEFAULT_JFROG_TOKEN_DURATION };
